import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Verify = () => {
  const [code, setCode] = useState(['', '', '', '']);
  const [error, setError] = useState('');
  const [email, setEmail] = useState(''); // to store email
  const navigate = useNavigate();

  useEffect(() => {
    // Retrieve email from localStorage
    const storedEmail = localStorage.getItem('forgotPasswordEmail');
    if (storedEmail) {
      setEmail(storedEmail);
    } else {
      // Redirect if email is not available
      navigate('/forget-password');
    }
  }, [navigate]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]?$/.test(value)) {
      let newCode = [...code];
      newCode[index] = value;
      setCode(newCode);
      if (value && index < 3) {
        document.getElementById(`code-${index + 1}`).focus();
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const verificationCode = code.join('');

    try {
      const response = await fetch(`${API_BASE}/user/verifyOTP`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ otp: verificationCode, email }),
      });

      const result = await response.json();

      if (response.ok) {
        navigate('/resetpassword');
      } else {
        setError(result.message || 'Verification failed. Please try again.');
      }
    } catch (error) {
      setError('An error occurred. Please try again later.');
    }
  };
const API_BASE = process.env.REACT_APP_API_BASE;

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-cover bg-center px-4"
      style={{
        backgroundImage:
          "url('https://media.istockphoto.com/id/1600711900/photo/hi-tech-digital-interior-abstract-data-center-server-business-technology-blured-polygonal.jpg?s=612x612&w=0&k=20&c=NLFY37Xwvd48JC418-hkAiLO-rddaoh3JfpWS8ODZo8=')",
      }}
    >
      <div className="w-full max-w-md bg-white bg-opacity-95 p-8 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold text-gray-800 text-center mb-6">Verify Your Code</h2>
        {error && <div className="text-red-500 text-center mb-4">{error}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex justify-center mb-5 space-x-2">
            {code.map((num, index) => (
              <input
                key={index}
                id={`code-${index}`}
                type="text"
                maxLength="1"
                value={num}
                onChange={(e) => handleChange(e, index)}
                className="w-12 h-12 text-center border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 text-lg"
              />
            ))}
          </div>
          <button
            type="submit"
            className="w-full py-2 bg-red-500 text-white font-semibold rounded-lg hover:bg-red-600"
          >
            Verify
          </button>
        </form>
      </div>
    </div>
  );
};

export default Verify;
